// Native blog posts — each gets its own URL (/blog/:slug) and self-referencing canonical.
export const BLOG_POSTS = [
  {
    slug: 'historic-pass-house-sold',
    title: '28 Years of Memories, One Sold Sign',
    subtitle: 'The Historic Pass House has SOLD',
    excerpt: 'Some homes are just houses. And some homes hold a family\'s whole life. The 185-year-old Pass House is proof that every home sells — when your agent has a plan built for it.',
    date: '2026-10-08',
    readTime: '3 min read',
    category: 'Sold Stories',
    cover: '/img/pass-house-poster.jpg',
    coverAlt: 'Jessica Burnette in front of the historic Pass House, now sold',
    video: { src: '/video/pass-house.mp4', poster: '/img/pass-house-poster.jpg', caption: 'They said it couldn\'t be sold. Watch the Pass House story.' },
    tags: ['Historic Homes', 'Sellers', 'Sold'],
    content: [
      { type: 'p', text: 'Some homes are just houses. And some homes hold a family\'s whole life. The Pass House is 185 years old. Cathy owned it for 28 and a half of those years. When she called me, selling wasn\'t just a transaction. It was closing a chapter.' },
      { type: 'video' },
      { type: 'h2', text: 'Historic homes need a plan, not a template' },
      { type: 'p', text: 'Historic homes scare some agents. They\'re different. They need different pricing, different marketing, different buyers. But different doesn\'t mean hard to sell. It means you need a plan built for that specific house, not a cookie cutter listing.' },
      { type: 'p', text: 'We priced it right. We told its story. And when the buyer\'s inspection flagged the fence, we negotiated a $1,000 repair credit and kept the deal moving instead of letting it fall apart. That\'s the unsexy part of selling a home that nobody posts about. It\'s phone calls and paperwork and refusing to let small things kill big deals.' },
      { type: 'h2', text: 'Closed October 5th. Five stars the next day.' },
      { type: 'p', text: 'We closed on October 5th. Cathy left me a five-star review the next day and headed off to Carolina for her next chapter.' },
      { type: 'p', text: 'If you\'ve been sitting on a home for years wondering whether it\'s sellable, or whether the market wants what you have, here\'s your answer. Every home sells. The question is whether your agent has a plan for yours.' },
      { type: 'cta', text: 'Thinking of selling? Don\'t stress. Call Jess and forget the rest.' },
    ],
  },
];

export const findPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);

export const formatPostDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
